import { ContentType } from "../Common/ContentType";
import { readObjectFromStorage, writeToStorage } from "./Storage";

export interface ICacheItem {
	contentType: ContentType;
	content: any;
	expiryDate: Date;
	lastRetrievedDate: Date;
}

export function saveToCache(contentType: ContentType, content: any, expiryTime: number, storageKey?: string): ICacheItem {
	const cacheItem = createItem(contentType, content, expiryTime);
	setItem(cacheItem, storageKey);
	return cacheItem;
}

export function updateCache(contentType: ContentType, content: any, expiryTime: number, storageKey?: string): ICacheItem {
	const cacheItem = getItem(storageKey);
	if (!cacheItem) {
		return saveToCache(contentType, content, expiryTime, storageKey);
	}

	cacheItem.content = content;
	setItem(cacheItem, storageKey);
	return cacheItem;
}

export function getCachedContent<T>(storageKey: string): T {
	const cacheItem = getItem(storageKey);
	return cacheItem && cacheItem.content;
}

export function getValidCachedContent<T>(storageKey: string, defaultValue: T): T {
	const cacheItem = getItem(storageKey);
	return isCacheItemExpired(cacheItem) ? defaultValue : cacheItem.content;
}

export function isCachedTypeExpired(storageKey: string): boolean {
	const cacheItem = getItem(storageKey);
	return isCacheItemExpired(cacheItem);
}

export function createItem(contentType: ContentType, content: any, expiryTime: number): ICacheItem {
	const cacheItem: ICacheItem = {
		contentType,
		content,
		expiryDate:  new Date(Date.now() + expiryTime),
		lastRetrievedDate: new Date(),
	};

	return cacheItem;
}

function isCacheItemExpired(cacheItem: ICacheItem): boolean {
	return !cacheItem
		|| !cacheItem.expiryDate
		|| cacheItem.expiryDate < new Date();
}

function setItem(cacheItem: ICacheItem, storageKey?: string): void {
	writeToStorage(storageKey ?? cacheItem.contentType, cacheItem);
}

function getItem(storageKey: string): ICacheItem {
	const cachedItem = readObjectFromStorage<ICacheItem>(storageKey);
	if (cachedItem) {
		cachedItem.expiryDate = typeof cachedItem.expiryDate === "string" ?
			new Date(cachedItem.expiryDate) : cachedItem.expiryDate;
	}

	return cachedItem;
}
